export default "__VITE_ASSET__DLRmFw4I__"